import type { ComponentPropsWithRef } from 'react'
import { useId } from 'react'

export interface RadioInputProps extends Omit<
    ComponentPropsWithRef<'input'>,
    'type' | 'value' | 'checked'
> {
    label: string
    value: string
    defaultChecked?: boolean
    useBookingFormThemeCssVariables?: boolean
}

export function RadioInput({
    label,
    value,
    id,
    disabled = false,
    useBookingFormThemeCssVariables = false,
    className = '',
    style,
    defaultChecked,
    ...inputProps
}: RadioInputProps) {
    const generatedId = useId()
    const inputId = id ?? generatedId

    const themeClassName = useBookingFormThemeCssVariables
        ? 'text-booking-form-theme-main-background-color focus:ring-booking-form-theme-main-background-color focus-visible:ring-booking-form-theme-main-background-color'
        : 'text-primary focus:ring-primary focus-visible:ring-primary'

    return (
        <div className="flex items-center gap-x-2">
            <input
                {...inputProps}
                id={inputId}
                type="radio"
                value={value}
                defaultChecked={defaultChecked}
                disabled={disabled}
                style={{
                    height: '1.35rem',
                    width: '1.35rem',
                    verticalAlign: 'middle',
                    ...style,
                }}
                className={`peer border border-gray-400 ${themeClassName} focus:ring-2 focus-visible:outline-none focus-visible:ring-2 disabled:cursor-not-allowed disabled:border-stone-300 disabled:bg-stone-100 disabled:text-gray-400 disabled:checked:bg-gray-400 disabled:checked:border-gray-400 disabled:checked:hover:bg-gray-400 disabled:hover:bg-stone-100 disabled:hover:border-stone-300 disabled:select-none cursor-pointer ${className}`.trim()}
            />
            <label
                htmlFor={inputId}
                className={`text-gray-800 select-none ${disabled ? 'text-gray-400 cursor-not-allowed' : 'cursor-pointer'}`.trim()}
            >
                {label}
            </label>
        </div>
    )
}
